
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "notificationWorker.3fbe094d163bfb42657a.worker.js", { name: "notificationWorker.[hash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "notificationWorker.3fbe094d163bfb42657a.worker.js");
					addMethods(w, methods)
					
					return w
				}
			